import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getCleanHTML } from 'shared/lib/getCleanHTML'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface AboutSectionProps {
  description: string
}

export const AboutSection = ({ description }: AboutSectionProps) => {
  const { t } = useTranslation()

  if (!description) return null

  return (
    <Paper
      padding={[12, 14]}
      radius="16"
    >
      <h3 className={clsx('bold-14', s.sectionTitle)}>
        {t('kyrgyzstan_block.option_detail.about_room')}
      </h3>
      <p
        className={clsx('medium-14', s.description)}
        dangerouslySetInnerHTML={{ __html: getCleanHTML(description) }}
      />
    </Paper>
  )
}
